import { apiFetch } from './interceptor';
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';

export const withdrawalsApi = {
    sendWithdrawal: async (token, params) => {
        const response = await apiFetch(`${BASE_URL}/withdrawals`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params)
        });
        const data = await response.json();
        return { status: response.status, data };
    },
    
    getWithdrawals: async (token, params) => {
        const response = await apiFetch(`${BASE_URL}/withdrawals?${new URLSearchParams(params).toString()}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        return { status: response.status, data };
    },

    approveWithdrawal: async (token, id, notes) => {
        const response = await apiFetch(`${BASE_URL}/withdrawals/${id}/approve`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ approvedNotes: notes })
        });
        return response.json();
    },

    declineWithdrawal: async (token, id, notes) => {
        const response = await apiFetch(`${BASE_URL}/withdrawals/${id}/decline`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ approvedNotes: notes })
        });
        return response.json();
    },

    getWithdrawalsCount: async (token) => {
        const response = await apiFetch(`${BASE_URL}/withdrawals/count/pending`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        return { status: response.status, data };
    }
};


